import { render, staticRenderFns } from "./EinstellungListungsgrenzenView.vue?vue&type=template&id=089cf92e&"
import script from "./EinstellungListungsgrenzenView.vue?vue&type=script&lang=js&"
export * from "./EinstellungListungsgrenzenView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports